import selectOption from '@/store/dict/selectOptionDict'
import { operateMaxShowLength } from '@/store/dict/config'

export default function () {
  return {
    headData: [
      {
        name: 'plateNo',
        columnProps: {
          prop: 'plateNo',
          label: '车牌号',
          width: 100,
        },
      },
      {
        name: 'brandName',
        columnProps: {
          prop: 'brandName',
          label: '品牌',
        },
      },
      {
        name: 'seriesName',
        columnProps: {
          prop: 'seriesName',
          label: '车系',
        },
      },
      {
        name: 'carModel',
        columnProps: {
          prop: 'carModel',
          label: '车型',
          width: 160,
        },
      },
      {
        name: 'provider',
        columnProps: {
          prop: 'provider',
          label: '车源方名称',
          width: 150,
        },
      },
      {
        name: 'gmtCreate',
        columnProps: {
          prop: 'gmtCreate',
          label: '子订单创建时间',
          width: 150,
        },
      },
      {
        name: 'rentAmount',
        columnProps: {
          prop: 'rentAmount',
          label: '每期租金(元)',
          width: 150,
        },
      },
      {
        name: 'deposit',
        columnProps: {
          prop: 'deposit',
          label: '押金',
          width: 150,
        },
      },
      {
        name: 'startDate',
        columnProps: {
          prop: 'startDate',
          label: '付款开始日',
          width: 150,
        },
      },
      {
        name: 'endDate',
        columnProps: {
          prop: 'endDate',
          label: '付款结束日',
          width: 150,
        },
      },
      {
        name: 'closeTime',
        columnProps: {
          prop: 'closeTime',
          label: '子订单关闭时间',
          width: 150,
        },
      },
      {
        name: 'state',
        columnProps: {
          prop: 'state',
          label: '子订单状态',
          width: 100,
        },
        getText: ({ row }) => selectOption.purchaseOrderState[row.state],
      },
      {
        name: 'purchaseOrderId',
        columnProps: {
          prop: 'purchaseOrderId',
          label: '采购订单ID',
          width: 100,
        },
      },
      {
        name: 'deptName',
        columnProps: {
          prop: 'deptName',
          label: '所属部门',
        },
      },
      {
        name: 'operate',
        columnProps: {
          label: '操作',
          width: 240,
          fixed: 'right',
        },
        maxShowLength: operateMaxShowLength,
        type: 'operate',
        getOperateList: ({ row }) => {
          const arr = []
          this.judgePermission('purchase_new_order_list_sub_car_detail') && arr.push({
            name: 'toCarDetail', label: '车辆详情', action: () => { this.toCarDetail(row) },
          })
          if (Number(row.state) !== 4 && this.judgePermission('purchase_new_order_list_sub_settlement')) {
            arr.push({
              name: 'exitCarSettle', label: '退车核算', action: () => { this.exitCarSettle(row) },
            })
          }
          return arr
        },
      },
    ],
  }
}

